module.exports = __webpack_public_path__ + "img/icon_win.e6f49ada.png";